import { produce } from 'immer';

import { RESET_STATE } from 'store/global/actions';

import { SEARCH_SYNONYMS_ACTION_TYPE } from '../actions/searchSynonyms.actions';

const initialState = [];

const searchSynonymsReducer = (state = initialState, { type, payload }) =>
  produce(state, draft => {
    switch (type) {
      case SEARCH_SYNONYMS_ACTION_TYPE.GET_SEARCH_SYNONYMS:
        return payload;

      case SEARCH_SYNONYMS_ACTION_TYPE.ADD_SEARCH_SYNONYM:
        if (payload) {
          draft.push(payload);
        }

        break;

      case SEARCH_SYNONYMS_ACTION_TYPE.UPDATE_SEARCH_SYNONYM: {
        const index = draft.findIndex(group => group.id === payload?.id);

        if (payload && index !== -1) {
          draft[index] = payload;
        }

        break;
      }

      case SEARCH_SYNONYMS_ACTION_TYPE.DELETE_SEARCH_SYNONYM:
        return state.filter(group => group.id !== payload);

      case RESET_STATE:
        return initialState;

      default:
        return state;
    }
  });

export default searchSynonymsReducer;
